import { useInfiniteQuery } from '@tanstack/react-query';

import { getToReceiveCrossdockingOrders } from '../../infra/api';

export default function useGetToReceiveCrossdockingOrders(filters) {
  return useInfiniteQuery({
    queryKey: ['get-to-receive-crossdocking-orders', filters],
    queryFn: ({ pageParam }) =>
      getToReceiveCrossdockingOrders({ ...filters, page: pageParam }),
    getNextPageParam: (lastPage) => {
      if (lastPage.data.current_page < lastPage.data.total_pages) {
        return lastPage.data.current_page + 1;
      }
      return undefined;
    },
    getPreviousPageParam: (firstPage) => {
      if (firstPage.data.current_page > 1) {
        return firstPage.data.current_page - 1;
      }
      return undefined;
    },
    initialPageParam: 1,
    enabled: !!filters.idRoute && !!filters.status,
  });
}
